// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"rich-text","577":"json-editor"}[chunkId] || chunkId) + "." + {"135":"b138905c","254":"d930f449","577":"413b30fa","761":"9ea24a91"}[chunkId] + ".chunk.js";
};